import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ["menu"]

  connect() {
    // Close menu when clicking outside
    this.clickOutside = this.clickOutside.bind(this)
  }

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    
    if (!this.menuTarget.classList.contains("hidden")) {
      document.addEventListener("click", this.clickOutside)
    } else {
      document.removeEventListener("click", this.clickOutside)
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden")
      document.removeEventListener("click", this.clickOutside)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside)
  }
}
